// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2m-6";
export var headerCell = "_2m-2";
export var loadingStateContent = "_2m-8";
export var rowWrapper = "_2m-4";
export var stickyAggregationCell = "_2m-b";
export var stickyAggregationRow = "_2m-7";
export var stickyColumnCell = "_2m-a";
export var stickyColumnHeaderCell = "_2m-9";
export var table = "_2m-1";
export var virtualRowWrapper = "_2m-5";
export var virtualTableBodyFiller = "_2m-d";
export var virtualTableBodyFillerBottom = "_2m-e";
export var virtualTableContainer = "_2m-0";
export var virtualTableContainerFill = "_2m-c";
export var white = "_2m-3";